import React, { useContext, useEffect } from "react";
import { Context } from "../Context";
import { useRouter } from "next/router";
import { updateLoanInfo } from "../utils/calcUtils";
import Image from "next/image";
import { getUrlParams } from "../utils/pageUtils";
import formModel from "../components/application/form/formModel";
import Step0 from "../components/application/steps/step0";
import { server } from "../../config";

export default function Index({ caid, application }) {
  const { setIpAddress, setId, loanInfo, setLoanInfo, setNewValues } =
    useContext(Context);

  const router = useRouter();

  let ipString = "";

  let amount = Number(loanInfo.amount);
  let months = Number(loanInfo.months);
  let nominalInterest = Number(process.env.INTEREST_RATE);
  let startupFee = Number(process.env.START_UP_FEE);
  let monthlyFee = Number(process.env.MONTHLY_FEE);
  let insuranceCostPercentage = Number(process.env.MONTHLYINSURANCECOST);

  useEffect(() => {
    if (window) {
      if (router.asPath.search("campaignId") > 1) {
        setNewValues(getUrlParams(router.asPath));
        if (caid) {
          let rastreatorUrl = `https://prestamos-personales.rastreator.com/pixel?bid=X&caid=${caid}&info=LANDING`;
          <Image
            src={rastreatorUrl}
            width={1}
            height={1}
            style={{ borderStyle: "none" }}
            alt=""
            onError={() => {
              const errorMessage = "Rastreator pixel failed to load.";
              console.log(errorMessage);
            }}
          />;
        }
      }
    }

    getIPAddress();

    async function getIPAddress() {
      try {
        const res = await fetch("https://api.ipify.org/?format=json")
          .then((response) => {
            if (!response.ok) {
              throw new Error(`HTTP error: ${response.status}`);
            }
            return response.json();
          })
          .then((data) => {
            if (ipString) {
              ipString.includes(data.ip) == false
                ? (ipString += ", " + data.ip)
                : console.log("This item already exists");
              setIpAddress(ipString);
            } else setIpAddress("" + data.ip);
          });
      } catch (error) {
        // TypeError: Failed to fetch
        console.log("There was an error", error);
      }
    }

    // if (window) {
    //   setId(window.crypto.randomUUID());
    // }

    const updatedLoanInfo = updateLoanInfo(
      nominalInterest,
      amount,
      months,
      startupFee,
      monthlyFee,
      application?.insurance?.Insurance === undefined ||
        application?.insurance?.Insurance
        ? insuranceCostPercentage
        : 0
    );

    setLoanInfo({
      amount: amount,
      months: months,
      nominalInterest: nominalInterest,
      startupFee: startupFee,
      monthlyFee: monthlyFee,
      totalCost: updatedLoanInfo.total,
      monthlyPayment: updatedLoanInfo.monthlyPayment,
      nominalEffInterest: updatedLoanInfo.nominalEffInterest,
      effectiveInterest: updatedLoanInfo.effectiveInterest,
      monthlyInsuranceCost: updatedLoanInfo.monthlyInsuranceCost,
    });
  }, []);

  return <Step0 formField={formModel} />;
}

export async function getServerSideProps(context) {
  const { req, res, query, params } = context;
  const { utm_source, utm_medium, utm_campaign, at_gd, caid } = query;

  context.res.setHeader("Set-Cookie", [
    `at_gd=${at_gd}; domain=.leabank.es path=/;`,
  ]);

  if (params && params.id) {
    const res2 = await fetch(
      `${server}/api/loanApplication/${params.id}`,
      {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    if (res2.status !== 200) {
      throw new Error(`There was an error with status code ${res2.status}`);
    }
    let application = await res2.json();
    return {
      props: {
        caid: caid ? caid : null,
        application: application ?? null,
      },
    };
  }

  return {
    props: {
      caid: caid ? caid : null,
    },
  };
}
